<script setup lang="ts">
import { breadcrumbTheme } from '#layers/ui/public';
</script>

<template>
	<span :class="breadcrumbTheme.slots.separator">/</span>
</template>
